import { createSlice } from "@reduxjs/toolkit";
import JsonParams from "meta/features/json-params";
const initialState = {
    locked: false,
    isLoading: false,
    appNameLongHtml: JsonParams.AppSettings.AppNameLongHtml,
};
export const lockScreenSlice = createSlice({
    name: "lockScreen",
    initialState,
    reducers: {
        lockScreen: (state) => {
            state.locked = true;
        },
        unlockScreen: (state) => {
            state.locked = false;
        },
        validateRequest: (state) => {
            state.isLoading = true;
        },
        validateSuccess: (state) => {
            state.isLoading = false;
            state.locked = false;
            state.message = undefined;
        },
        validateError: (state, action) => {
            (state.isLoading = false), (state.message = action.payload);
        },
    },
});
export const { lockScreen, unlockScreen, validateRequest, validateSuccess, validateError, } = lockScreenSlice.actions;
export default lockScreenSlice.reducer;
